import { render, staticRenderFns } from "./homeContents.vue?vue&type=template&id=3f6db85c&scoped=true&"
import script from "./homeContents.vue?vue&type=script&lang=js&"
export * from "./homeContents.vue?vue&type=script&lang=js&"
import style0 from "./homeContents.vue?vue&type=style&index=0&id=3f6db85c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6db85c",
  null
  
)

export default component.exports